import { render, staticRenderFns } from "./AnonymizeConfirmed.vue?vue&type=template&id=31b74324"
import script from "./AnonymizeConfirmed.vue?vue&type=script&lang=js"
export * from "./AnonymizeConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports